import { object, string } from 'yup';
import { CreateCommand } from '../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../enums.js';

const SCHEMA = object({
  id: string().required(),
  current_stage_id: string().required(),
});

/**
 * CardUnarchivedEvent
 *
 * - Evento emitido quando um card é desarquivado.
 */
export class CardUnarchivedEvent extends CreateCommand(RealtimeEventType.CardUnarchived, SCHEMA) {}
